import { GetStaticPaths, GetStaticProps } from 'next';

import ApiService from '@/lib/api';
import MainLayout from '../../layouts/MainLayout';
import Profile from '@/components/Profile';
import { withSiteName } from '@/utils/pageTitle';

export const getStaticPaths: GetStaticPaths = async () => {
  const apiService = new ApiService();
  const pageRoutes = await apiService.getMemberProfilePath();

  return {
    paths: pageRoutes
      .filter((route) => route.slug && typeof route.slug === 'string')
      .map((route) => ({
        params: { slug: route.slug },
      })),
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps = async ({ params: { slug }, preview = false }) => {
  const apiService = new ApiService();
  const [data, menuData, { teamProfiles = {}, footer }] = await Promise.all([
    apiService.getMemberProfile(slug as string, preview),
    apiService.getMenuData(),
    apiService.getMiscData(),
  ]);
  return {
    props: {
      profile: data,
      teamProfiles,
      menuData,
      footer,
      slug,
    },
    revalidate: 3600,
  };
};

const ProfilePage = ({ profile, teamProfiles, menuData, footer, slug }) => {
  const ogUrl = `https://foxbox.com/team-profiles/${slug}`;
  return (
    <MainLayout
      bgWhite={true}
      navIsFixed={false}
      navIsDark={true}
      ogUrl={ogUrl}
      menuData={menuData}
      footer={footer}
      metaTitle={profile?.seo?.title || withSiteName(profile?.name)}
      metaDescription={profile?.seo?.description || profile?.shortBio}
    >
      <Profile profile={profile} teamProfiles={teamProfiles} />
    </MainLayout>
  );
};

export default ProfilePage;
